<template>

  <div class="bill-info">
     <KTCodePreview v-bind:title="''"
      > <template v-slot:preview
        > <b-card
          no-body
          class="full-width"
          >
          <div>

            <div
              class="wizard wizard-4"
              id="kt_wizard_v4_bill"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
               <!--begin: Wizard Nav-->
              <div
                class="wizard-nav wizard-nav-bg"
                style="border-radius: 0px"
              >

                <div class="wizard-steps">
                   <!-- Thông tin -->
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Thông tin</div>

                      </div>

                    </div>

                  </div>
                   <!-- Lịch sử -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Lịch sử</div>

                      </div>

                    </div>

                  </div>
                   <!-- Tệp đính kèm -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Tệp đính kèm</div>

                      </div>

                    </div>

                  </div>
                   <!-- Phiếu thu cũ -->
                  <div
                    class="wizard-step ml-1"
                    data-wizard-type="step"
                    v-show="mainModel.id"
                  >

                    <div class="wizard-wrapper p-2">

                      <div class="wizard-label">

                        <div class="wizard-title">Phiếu thu cũ</div>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <div class="card card-custom card-shadowless rounded-top-0">
                 <b-skeleton-wrapper :loading="!renderComponent"
                  > <template #loading
                    >
                    <div class="card-body">
                       <b-row
                        > <b-col md="9"
                          >
                          <div class="mb-4 d-flex d-inline">
                             <b-skeleton
                              animation="wave"
                              width="18%"
                              class="mr-2"
                            ></b-skeleton
                            > <b-skeleton
                              animation="wave"
                              width="82%"
                            ></b-skeleton
                            >
                          </div>
                           <b-skeleton-table
                            :rows="4"
                            :columns="4"
                            :table-props="{ bordered: true, striped: true }"
                          ></b-skeleton-table
                          > <b-row
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > <b-col md="4"
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="50%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > <b-skeleton
                                animation="fade"
                                width="100%"
                                class="mb-4"
                              ></b-skeleton
                              > </b-col
                            > </b-row
                          > </b-col
                        > <b-col md="3"
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="50%"
                            class="mb-4"
                          ></b-skeleton
                          > <b-skeleton
                            animation="fade"
                            width="100%"
                            class="mb-4"
                          ></b-skeleton
                          > </b-col
                        > </b-row
                      >
                    </div>
                     </template
                  >
                  <div class="card-body">

                    <div class="row">
                       <!-- Thông tin -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                          data-wizard-state="current"
                        >
                           <b-row
                            class="col-md-12 mb-1 m-0 p-0"
                            v-if="isShowOrderNotCompleted"
                            >
                            <div
                              class="alert-header"
                              style="width: 100%"
                            >
                               Khách hàng này đang có đơn hàng chưa được hoàn tất
                              <ul
                                style="
                                  padding-left: 15px;
                                  line-height: 20px;
                                  margin-top: 5px;
                                  list-style: circle;
                                "
                              >

                                <li
                                  v-for="(order, i) in notCompleteOrders"
                                  :key="i"
                                >

                                  <div class="row">
                                     <span class="ml-2 mr-2">Đơn hàng</span>
                                    <div
                                      class="orderCode"
                                      @click="linkToOrder(order.id)"
                                      style="cursor: pointer"
                                    >
                                       <span
                                        v-text="order.id"
                                        class="text-primary"
                                      ></span
                                      >
                                    </div>

                                  </div>

                                </li>

                              </ul>

                            </div>
                             </b-row
                          > <b-row
                            class="col-md-12 mb-1 m-0 p-0"
                            v-if="mainModel.orderId"
                            >
                            <div
                              class="alert-header"
                              style="width: 100%"
                            >
                               Chuyển đơn hàng <span
                                class="text-primary"
                                style="cursor: pointer"
                                @click="linkToOrder(mainModel.orderId)"
                                >{{ mainModel.orderId }}</span
                              > sang hóa đơn bán lẻ .
                              <ul
                                style="
                                  padding-left: 15px;
                                  line-height: 20px;
                                  margin-top: 5px;
                                  list-style: circle;
                                "
                              >

                                <li v-show="mainModel.moneyPaid > 0">
                                   Số tiền đã đặt cọc: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyPaid) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyTransfered > 0">
                                   Số tiền đã chuyển khoản: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyTransfered) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyCredit > 0">
                                   Số tiền quẹt thẻ: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyCredit) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.moneyInstallment > 0">
                                   Số tiền đã trả góp: <span class="text-primary"
                                    > {{ convertPrice(mainModel.moneyInstallment) }} </span
                                  >
                                </li>

                                <li v-show="mainModel.customerShipFee > 0">
                                   Phí ship: <span class="text-primary"
                                    > {{ convertPrice(mainModel.customerShipFee) }} </span
                                  >
                                </li>

                              </ul>
                               Mã vận đơn: <span class="text-primary"
                                > {{ mainModel.codeShip }} </span
                              >
                            </div>
                             </b-row
                          >
                          <BillEInvoiceLockAlert :einvoice="mainModel.einvoice" />
                          <b-row
                            class="mb-2 mt-1 mx-0 p-0"
                            v-if="mainModel.billNumber"
                          >
                            <b-col cols="12">
                              <div
                                class="d-flex align-items-center justify-content-start"
                                style="font-size: 1.125rem; font-weight: 600; color: #212121"
                              >
                                <i
                                  class="fa fa-receipt text-warning mr-2"
                                  style="font-size: 1.3rem"
                                ></i>
                                <span>
                                  Mã hóa đơn:
                                  <span class="text-danger">#{{ mainModel.billNumber }}</span>
                                </span>
                                <span class="mx-3 text-muted">|</span>
                                <span
                                  class="text-muted"
                                  style="font-weight: normal; font-size: 1rem"
                                >
                                  Ngày tạo: {{ mainModel.billCreatedAt }}
                                </span>
                              </div>
                            </b-col>
                          </b-row>
                          <!-- ── B2B: thông tin khách hàng + hợp đồng + giao hàng (nằm TRÊN bảng SP) ── -->
                          <template v-if="isWholesaleInvoice && renderComponent">
                            <p class="text-dark font-size-h5 font-weight-bold mt-5 mb-3 ml-3">Thông tin khách hàng</p>
                            <b-row class="col-md-12 m-0 p-0 mb-2">
                              <b-col md="12" class="p-0">
                                <WholesaleCustomerInfo
                                  :billData="mainModel"
                                  v-on:onUpdate="onUpdateCustomer"
                                />
                              </b-col>
                            </b-row>
                            <b-row class="col-md-12 m-0 p-0 mb-2">
                              <b-col md="4">
                                <b-form-group>
                                  <label>Người nhận hàng:</label>
                                  <b-form-input size="sm" v-model="mainModel.receiverName" placeholder="Tên người nhận" />
                                </b-form-group>
                              </b-col>
                              <b-col md="4">
                                <b-form-group>
                                  <label>SĐT người nhận:</label>
                                  <b-form-input size="sm" v-model="mainModel.receiverMobile" placeholder="SĐT người nhận" />
                                </b-form-group>
                              </b-col>
                              <b-col md="4">
                                <b-form-group>
                                  <label>Địa chỉ giao hàng:</label>
                                  <b-form-input size="sm" v-model="mainModel.receiverAddress" placeholder="Địa chỉ giao hàng" />
                                </b-form-group>
                              </b-col>
                            </b-row>
                            <b-row class="col-md-12 m-0 p-0 mb-2">
                              <b-col md="4">
                                <b-form-group>
                                  <label>Số hóa đơn VAT:</label>
                                  <b-form-input size="sm" v-model.trim="mainModel.invoiceNo" placeholder="Số hợp đồng" disabled />
                                </b-form-group>
                              </b-col>
                              <b-col md="4">
                                <b-form-group>
                                  <label>Số seri:</label>
                                  <b-form-input size="sm" v-model.trim="mainModel.serial" placeholder="Số seri" disabled />
                                </b-form-group>
                              </b-col>
                              <b-col md="4">
                                <b-form-group>
                                  <label>Nguồn đơn hàng:</label>
                                  <treeselect
                                    :load-options="loadOptionOrderSources"
                                    :options="optionOrderSources"
                                    :auto-load-root-options="false"
                                    :multiple="false"
                                    placeholder="Nhập nguồn đơn hàng"
                                    retryText="Thử lại..."
                                    retryTitle="Nhấp thử lại"
                                    loadingText="Đang tải..."
                                    noResultsText="Không có kết quả"
                                    :match-keys="['label']"
                                    :value="mainModel.orderSourceName"
                                    v-model="mainModel.orderSourceId"
                                    openDirection="bottom"
                                  />
                                </b-form-group>
                              </b-col>
                            </b-row>
                          </template>

                          <b-row
                            v-if="mainModel.hasExchange"
                            class="col-md-12 mb-2 m-0 p-0"
                          >
                            <b-alert show variant="warning" class="mb-0 w-100">
                              <i class="fas fa-exchange-alt mr-1"></i>
                              Hóa đơn đã có phiếu xuất đổi
                              <span
                                v-for="(num, idx) in mainModel.exchangeBillNumbers"
                                :key="num"
                              >
                                <router-link
                                  :to="{ name: 'update-wholesale-invoice', query: { id: num } }"
                                  class="font-weight-bold"
                                >#{{ num }}</router-link><span v-if="idx < mainModel.exchangeBillNumbers.length - 1">, </span>
                              </span>.
                              Không được thay đổi thông tin sản phẩm.
                            </b-alert>
                          </b-row>

                          <b-row class="col-md-12 mb-1 m-0 p-0 bill-main-sections"
                            > <b-col
                              md="9"
                              :class="['mb-2 bill-main-sections__left', {'bill-main-sections__left--wholesale': isWholesaleInvoice}]"
                              > <BillProduct
                                v-if="!isWholesaleInvoice"
                                :billModel="mainModel"
                              /> <WholesaleBillProduct
                                v-else
                                :billModel="mainModel"
                              />
                              <!-- B2B: hàng ngang nhân viên + ghi chú -->
                              <template v-if="isWholesaleInvoice">
                                <p class="text-dark font-size-h5 font-weight-bold mb-3 mt-3">Nhân viên phụ trách</p>
                                <b-row class="mb-2">
                                  <b-col md="3">
                                    <b-form-group>
                                      <label>Người lập phiếu:</label>
                                      <Autosuggest :model.sync="mainModel.billEmployeeInfo.cashierName" :suggestions="filteredEmployeeOptions" placeholder="Nhập nhân viên" :limit="10" :disabled="mainModel.id" @select="onSelectEmployee($event, 'Cashier')" @change="onEmployeeInputChange">
                                        <template #custom="{ suggestion }"><div><span>{{ suggestion.item.fullName }}</span><span class="text-primary" v-if="suggestion.item.code"> - {{ suggestion.item.code }}</span></div></template>
                                      </Autosuggest>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="3">
                                    <b-form-group>
                                      <label>NV Kinh doanh:</label>
                                      <Autosuggest :model.sync="mainModel.billEmployeeInfo.saleName" :suggestions="filteredAllEmployeeOptions" placeholder="Nhập nhân viên" :limit="10" @select="onSelectEmployee($event, 'Sale')" @change="onAllEmployeeInputChange">
                                        <template #custom="{ suggestion }"><div><span>{{ suggestion.item.fullName }}</span><span class="text-primary" v-if="suggestion.item.code"> - {{ suggestion.item.code }}</span></div></template>
                                      </Autosuggest>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="3">
                                    <b-form-group>
                                      <label>NV Điều phối:</label>
                                      <Autosuggest :model.sync="mainModel.billEmployeeInfo.assistantName" :suggestions="filteredAllEmployeeOptions" placeholder="Nhập nhân viên" :limit="10" @select="onSelectEmployee($event, 'Assistant')" @change="onAllEmployeeInputChange">
                                        <template #custom="{ suggestion }"><div><span>{{ suggestion.item.fullName }}</span><span class="text-primary" v-if="suggestion.item.code"> - {{ suggestion.item.code }}</span></div></template>
                                      </Autosuggest>
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="3">
                                    <b-form-group>
                                      <label>NV Giao hàng:</label>
                                      <Autosuggest :model.sync="mainModel.billEmployeeInfo.shipperName" :suggestions="filteredAllEmployeeOptions" placeholder="Nhập nhân viên" :limit="10" @select="onSelectEmployee($event, 'Shipper')" @change="onAllEmployeeInputChange">
                                        <template #custom="{ suggestion }"><div><span>{{ suggestion.item.fullName }}</span><span class="text-primary" v-if="suggestion.item.code"> - {{ suggestion.item.code }}</span></div></template>
                                      </Autosuggest>
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                                <p class="text-dark font-size-h5 font-weight-bold mb-3 mt-3">Ghi chú</p>
                                <b-row>
                                  <b-col md="4">
                                    <b-form-group>
                                      <label>Ghi chú bán hàng:</label>
                                      <b-form-textarea size="sm" class="input-style" v-model="mainModel.billNote.customerNote" placeholder="Thêm ghi chú" :rows="3" :max-rows="6" />
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="4">
                                    <b-form-group>
                                      <label>Ghi chú nội bộ:</label>
                                      <b-form-textarea size="sm" class="input-style" v-model="mainModel.billNote.saleNote" placeholder="Thêm ghi chú nội bộ" :rows="3" :max-rows="6" />
                                    </b-form-group>
                                  </b-col>
                                  <b-col md="4">
                                    <b-form-group>
                                      <label>Ghi chú bảo hành:</label>
                                      <b-form-textarea size="sm" class="input-style" v-model="mainModel.billNote.warrantyNote" placeholder="Thêm ghi chú bảo hành" :rows="3" :max-rows="6" />
                                    </b-form-group>
                                  </b-col>
                                </b-row>
                              </template>
                              <!-- Retail: layout gốc 3 cột -->
                              <b-row v-else>
                                <b-col md="4">
                                  <CustomerInfo
                                    v-if="renderComponent"
                                    :billData="mainModel"
                                    v-on:onUpdate="onUpdateCustomer"
                                    v-on:show-orders="showOrders"
                                  />
                                  <b-form-group>
                                    <label class="required-control">Nguồn đơn hàng:</label>
                                    <treeselect
                                      :load-options="loadOptionOrderSources"
                                      :options="optionOrderSources"
                                      :auto-load-root-options="false"
                                      :multiple="false"
                                      placeholder="Nhập nguồn đơn hàng"
                                      retryText="Thử lại..."
                                      retryTitle="Nhấp thử lại"
                                      loadingText="Đang tải..."
                                      noResultsText="Không có kết quả"
                                      :match-keys="['label']"
                                      :value="mainModel.orderSourceName"
                                      v-model="mainModel.orderSourceId"
                                      openDirection="bottom"
                                    />
                                  </b-form-group>
                                </b-col>
                                <b-col md="4">
                                  <EmployeeInfo
                                    :storeId="mainModel.storeId"
                                    :billDataEmployeeInfo="mainModel.billEmployeeInfo"
                                  />
                                </b-col>
                                <b-col md="4">
                                  <BillNote :billNote="mainModel.billNote" />
                                </b-col>
                              </b-row> </b-col
                            > <b-col
                              md="3"
                              class="mb-2 bill-main-sections__right"
                              > <BillCheckoutForm
                                :billModel="mainModel"
                                v-if="renderComponent"
                              /> </b-col
                            > </b-row
                          > <b-row class="col-md-12 mb-1 m-0 p-0"
                            > <b-container class="p-0"
                              >
                              <hr
                                class="hr-text"
                                data-content="Bút Toán"
                                style="font-weight: 600"
                              />
                               <b-row
                                > <b-col
                                  md="12"
                                  lg="12"
                                  sm="12"
                                  > <BillTransactions :billNumber="$route.query.id" /> </b-col
                                > </b-row
                              >
                              <div style="position: sticky; top: 200px">
                                 <b-row
                                  > <b-col
                                    > <b-button
                                      style="font-weight: 600; width: 70px; margin-right: 10px"
                                      variant="primary"
                                      size="sm"
                                      @click="onSubmit('save')"
                                      :disabled="onSubmiting || !mainModel.editable"
                                      >Lưu</b-button
                                    > <b-button
                                      v-if="mainModel.billNumber"
                                      style="margin-right: 10px; font-weight: 600; width: 100px"
                                      variant="warning"
                                      size="sm"
                                      @click="onSubmit('save-print')"
                                      :disabled="onSubmiting || !mainModel.editable"
                                      > Lưu và in </b-button
                                    > <router-link
                                      to="/bills"
                                      tag="button"
                                      > <b-button
                                        tabindex="16"
                                        style="font-weight: 600; width: 70px"
                                        variant="secondary"
                                        size="sm"
                                        >Hủy</b-button
                                      > </router-link
                                    > </b-col
                                  > </b-row
                                >
                              </div>
                               </b-container
                            > </b-row
                          >
                        </div>

                      </div>
                       <!-- Lịch sử -->
                      <div class="col-xl-12">

                        <div
                          class="py-4 mb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-table
                              :fields="historyFields"
                              :items="histories"
                              class="table-bordered table-hover col-md-6"
                              > <template v-slot:cell(updatedBy)="row"
                                >
                                <div class="d-flex flex-column">
                                   <strong>{{ row.item.createdByName }}</strong
                                  > <small class="text-muted">{{ row.item.createdAt }}</small
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(userAgent)="row"
                                >
                                <div class="d-flex flex-column">
                                   <span><strong>IP:</strong> {{ row.item.userIP }}</span
                                  > <span class="text-muted"
                                    > OS: {{ row.item.userAgent.osName }} </span
                                  > <span class="text-muted"
                                    > Browser: {{ row.item.userAgent.browserName }} </span
                                  >
                                </div>
                                 </template
                              > <template v-slot:cell(detail)="row"
                                >
                                <div
                                  class="orderCode"
                                  @click="openHistoryModal(row.item.id)"
                                  style="cursor: pointer; color: #3699ff; font-weight: 500"
                                >
                                   #{{ row.item.id }}
                                </div>
                                 </template
                              > <template v-slot:cell(action)="row"
                                > <b-badge
                                  :variant="
                                    row.item.action === 1
                                      ? 'warning'
                                      : row.item.action === 4
                                        ? 'info'
                                        : 'danger'
                                  "
                                  > {{
                                    row.item.action === 1
                                      ? 'Sửa hóa đơn'
                                      : row.item.action === 4
                                        ? 'Sửa ghi chú'
                                        : 'Xóa hóa đơn'
                                  }} </b-badge
                                > </template
                              > </b-table
                            > </b-container
                          >
                        </div>

                      </div>
                       <!-- Tệp đính kèm -->
                      <div class="col-xl-12">

                        <div
                          class="pb-5 full-width"
                          data-wizard-type="step-content"
                        >
                           <b-container class="bv-example-row"
                            > <b-row
                              >
                              <div class="w-100">
                                 <upload-file
                                  :model-id="mainModel.billNumber"
                                  :model-name="'bills'"
                                  :max-files="10"
                                  :max-file-size="5 * 1024 * 1024"
                                />
                              </div>
                               </b-row
                            > </b-container
                          >
                        </div>

                      </div>
                       <!-- Phiếu thu cũ -->
                      <div
                        class="py-4 mb-5 full-width"
                        data-wizard-type="step-content"
                      ></div>

                    </div>

                  </div>
                   </b-skeleton-wrapper
                >
              </div>

            </div>

          </div>
           <BillHistoryModal
            :show="showHistoryModal"
            :history-id="selectedHistoryId"
            @update:show="showHistoryModal = $event"
            @open-modal="handleOpenModalFromUrl"
          /> </b-card
        > </template
      > </KTCodePreview
    >
  </div>

</template>

<script>
  import KTCodePreview from '@/view/content/CodeTab.vue'
  import KTWizard from '@/assets/js/components/wizard'
  import _uniq from 'lodash/uniq'
  import _isEmplty from 'lodash/isEmpty'
  import KTUtil from '@/assets/js/components/util'
  import ApiService from '@/core/services/api.service'
  import moment from 'moment'
  import apiCommonMixin from '@/view/mixins/api-common.mixins.js'
  import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module'
  import { TIME_TRIGGER } from '@/utils/constants'
  import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue'
  import BillCheckoutForm from '@/view/components/bills/BillCheckoutForm.vue'
  import BillProduct from '@/view/components/bills/BillProduct.vue'
  import WholesaleBillProduct from '@/view/components/bills/WholesaleBillProduct.vue'
  import CustomerInfo from '@/view/components/customers/CustomerInfo.vue'
  import WholesaleCustomerInfo from '@/view/components/customers/WholesaleCustomerInfo.vue'
  import EmployeeInfo from '@/view/components/bills/EmployeeInfo.vue'
  import BillNote from '@/view/components/bills/BillNote.vue'
  import BillTransactions from '@/view/components/bills/BillTransactions.vue'
  import BillHistoryModal from '@/view/components/bills/BillHistoryModal.vue'
  import BillEInvoiceLockAlert from '@/view/components/bills/BillEInvoiceLockAlert.vue'
  import { makeToastFaile, makeToastSuccess, cloneDeep, convertPrice } from '@/utils/common'
  import { logBillPaymentDebug, getFirstPaymentRefId, getFirstPaymentRow } from '@/utils/billPaymentDebug'
  import { ITEM_TYPE, AMOUNT_TYPE, PRODUCT_TYPE, PAYMENT_TYPE, BILL_TYPE } from '@/utils/enum'
  import UploadFile from '@/view/modules/upload-v2/Upload.vue'
  import Treeselect from '@riophae/vue-treeselect'
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import sortListBillItem from '../../components/bills/helpers/sortListBillItem'
  import {
    mergeWholesaleImeiBillRowsForDisplay,
    expandWholesaleImeiMainToPayloadRows,
  } from '@/view/components/bills/helpers/wholesaleImeiBillTransform'
  import {
    appendStackAmountsIfNeeded,
    hydrateSplitAmountsFromApi,
  } from '@/utils/voucherDiscountStack'
  import { normalizePromotionLabelsFromHydrate } from '@/utils/discountProgramDisplay'

  export default {
    props: {
      billType: {
        type: Number,
        required: true,
      },
    },
    mixins: [apiCommonMixin],
    data() {
      return {
        mainModel: {
          id: null,
          billNumber: null,
          billType: this.billType,
          storeId: null,
          storeName: '',
          orderId: null,
          discountType: 1,
          discountAmount: 0,
          couponCode: '',
          editable: true,
          einvoice: {
            exists: false,
            workState: 'none',
            recordId: null,
            recordStatus: null,
            taxStatus: null,
            invoiceNo: null,
            pattern: null,
            serial: null,
            issuedAt: null,
            errorMessage: null,
          },
          hasExchange: false,
          exchangeBillNumbers: [],
          billItems: [],
          receiverName: '',
          receiverMobile: '',
          receiverAddress: '',
          customerModel: {
            customerId: null,
            customerName: '',
            customerMobile: '',
            customerEmail: '',
            customerAddress: '',
            customerCity: '',
            customerDistrict: '',
            customerWard: '',
            customerNote: '',
            customerPoint: 0,
            customerType: 1,
            customerStatus: 1,
            customerCreatedAt: '',
            customerTaxCode: '',
          },
          orderSourceId: null,
          employeeModel: {
            employeeId: null,
            employeeName: '',
            employeeMobile: '',
            employeeEmail: '',
          },
          billEmployeeInfo: {
            saleId: null,
            saleName: '',
            technicalId: null,
            technicalName: '',
            cashierId: null,
            cashierName: '',
            accessoryStaffId: null,
            accessoryStaffName: '',
            managerId: null,
            managerName: '',
            assistantId: null,
            assistantName: '',
            customerReceptionId: null,
            customerReceptionName: '',
            shipperId: null,
            shipperName: '',
          },
          billNote: {
            customerNote: '',
            saleNote: '',
            warrantyNote: '',
          },
          vatInvoice: {
            vatCompanyType: 1,
            taxCode: '',
            companyAddress: '',
            companyName: '',
            email: '',
          },
          paymentInfo: {
            //tiền mặt
            cashAmount: 0,
            cashAccountantName: '',
            cashAccountId: null,
            //chuyển khoản
            transferAmount: 0,
            transferAccountantName: '',
            transferAccountantId: null,
            transferReferenceCode: '',
            //quẹt thẻ
            creditAmount: 0,
            creditAccountantName: '',
            creditAccountantId: null,
            creditCode: '',
            creditCardNo: '',
            //phí quẹt thẻ
            creditCardFee: 0,
            creditFeeAccountantName: '',
            creditFeeAccountantId: null,
            payCreditFeeType: 1,
            //trả góp
            installedMoneyAmount: 0,
            installmentCode: '',
            installmentAccountName: '',
            installMoneyAccountId: null,
            customerIndentifyNo: '',
            installmentProgramMonthNo: 0,
            installmentProgramPrepayPercent: 0,
          },
          installments: [],
          credits: [],
          transfer: [],
          cash: [],
          refunds: [],
          customerShipFee: 0,
            // B2B wholesale fields
          invoiceNo: null,
          serial: null,
        },
        renderComponent: false,
        optionOrderSources: null,
        filteredEmployeeOptions: [],
        optionsEmployee: [{ data: [] }],
        filteredAllEmployeeOptions: [],
        optionsAllEmployees: [{ data: [] }],
        onSubmiting: false,
        historyFields: [
          {
            key: 'updatedBy',
            label: 'Người thao tác',
            thStyle: { textAlign: 'center', width: '20%' },
          },
          {
            key: 'action',
            label: 'Hành động',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'userAgent',
            label: 'Thông tin thiết bị',
            sortable: false,
            thStyle: {
              textAlign: 'center',
              color: 'rgb(24, 28, 50)',
              width: '30%',
            },
          },
          {
            key: 'detail',
            label: 'Chi tiết',
            sortable: false,
            thStyle: { textAlign: 'center', color: 'rgb(24, 28, 50)' },
          },
        ],
        histories: [],
        showHistoryModal: false,
        selectedHistoryId: null,
        notCompleteOrders: [],
      }
    },
    components: {
      KTCodePreview,
      Autosuggest,
      BillProduct,
      WholesaleBillProduct,
      BillCheckoutForm,
      CustomerInfo,
      WholesaleCustomerInfo,
      EmployeeInfo,
      BillNote,
      Treeselect,
      BillTransactions,
      BillHistoryModal,
      UploadFile,
      BillEInvoiceLockAlert,
    },
    async mounted() {
      const billTypeName = this.billType === BILL_TYPE.WHOLESALE_INVOICE ? 'bán buôn' : 'bán lẻ'
      const billRoute =
        this.billType === BILL_TYPE.WHOLESALE_INVOICE ? '/wholesale-invoice' : '/bills'
      this.initialTab()
      this.mainModel.billNumber = this.$route.query.id ? this.$route.query.id : null
      const actionName = this.mainModel.billNumber ? 'Cập nhật' : 'Thêm mới'
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: `Hóa đơn ${billTypeName}`, route: billRoute },
        { title: `Danh sách hóa đơn ${billTypeName}`, route: billRoute },
        { title: `${actionName} hóa đơn ${billTypeName}` },
      ])
      this.mainModel.orderId = this.$route.query.fromOrderId ? this.$route.query.fromOrderId : null
      if (this.isWholesaleInvoice) {
        this.fetchAllEmployees()
      }
      if (this.mainModel.billNumber) {
        this.getBillByBillNumber()
        this.fetchBillHistory()
        this.checkModalFromUrl()
      } else {
        if (this.mainModel.orderId) {
          this.getOrderById()
        } else {
          this.renderComponent = true
        }
      }
    },
    watch: {
      'mainModel.storeId': {
        handler(newVal, oldVal) {
          if (newVal && this.isWholesaleInvoice) {
            this.fetchWholesaleEmployees(newVal, !!oldVal && oldVal !== newVal)
          }
        },
      },
    },
    computed: {
      isWholesaleInvoice() {
        return this.billType === BILL_TYPE.WHOLESALE_INVOICE
      },
      hasEInvoiceLock() {
        const einvoice = this.mainModel && this.mainModel.einvoice
        return Boolean(einvoice && einvoice.workState && einvoice.workState !== 'none')
      },
      isShowOrderNotCompleted() {
        if (this.mainModel.id) {
          return false
        }
        if (_isEmplty(this.notCompleteOrders)) {
          return false
        }

        if (!this.mainModel.orderId) {
          return true
        }

        const fromOrderNotComplete = this.notCompleteOrders.find(
          (order) => order.id === Number(this.mainModel.orderId),
        )
        return fromOrderNotComplete ? false : true
      },
    },
    methods: {
      convertPrice,
      fetchAllEmployees() {
        ApiService.get('v1/employees/all').then(({ data }) => {
          this.optionsAllEmployees[0].data = (data.data || []).map((e) => ({
            id: e.id,
            code: e.code || '',
            fullName: e.fullName || '',
          }))
          this.filteredAllEmployeeOptions = [...this.optionsAllEmployees[0].data]
        })
      },
      fetchWholesaleEmployees(storeId, reset) {
        if (reset) {
          this.mainModel.billEmployeeInfo = {
            saleId: null, saleName: '', cashierId: null, cashierName: '',
            assistantId: null, assistantName: '', shipperId: null, shipperName: '',
          }
        }
        ApiService.get(`v1/employees/by-store?storeIds=${storeId}`).then(({ data }) => {
          this.optionsEmployee[0].data = (data.data || []).map((e) => ({
            id: e.id, code: e.code || '', fullName: e.fullName || '',
          }))
          this.filteredEmployeeOptions = [...this.optionsEmployee[0].data]
        })
      },
      onEmployeeInputChange(text) {
        const q = (text || '').toLowerCase()
        this.filteredEmployeeOptions = this.optionsEmployee[0].data
          .filter((e) => e.fullName.toLowerCase().includes(q) || e.code.toLowerCase().includes(q))
          .slice(0, 10)
      },
      onAllEmployeeInputChange(text) {
        const q = (text || '').toLowerCase()
        this.filteredAllEmployeeOptions = this.optionsAllEmployees[0].data
          .filter((e) => e.fullName.toLowerCase().includes(q) || e.code.toLowerCase().includes(q))
          .slice(0, 10)
      },
      onSelectEmployee(option, type) {
        const emp = option.item
        const info = this.mainModel.billEmployeeInfo
        if (type === 'Sale') { info.saleId = emp.id; info.saleName = emp.fullName }
        else if (type === 'Cashier') { info.cashierId = emp.id; info.cashierName = emp.fullName }
        else if (type === 'Assistant') { info.assistantId = emp.id; info.assistantName = emp.fullName }
        else if (type === 'Shipper') { info.shipperId = emp.id; info.shipperName = emp.fullName }
      },
      initialTab() {
        // Initialize form wizard
        const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : ''

        this.hashName = hashName === 'attach' ? 'attach' : null

        const wizard = new KTWizard('kt_wizard_v4_bill', {
          startStep: hashName === 'attach' ? 3 : 1, // initial active step number
          clickableSteps: true, // allow step clicking
        })

        wizard.on('beforeNext', function (/*wizardObj*/) {})

        wizard.on('change', function (/*wizardObj*/) {
          setTimeout(() => {
            KTUtil.scrollTop()
          }, TIME_TRIGGER)
        })
      },
      onBack() {
        const routerName =
          this.billType === BILL_TYPE.WHOLESALE_INVOICE ? 'list-wholesale-invoice' : 'list-bill'
        this.$router.push({
          name: routerName,
        })
      },
      calcPaymentsAmount(items) {
        return items.reduce((result, item) => {
          const unMask = item.paymentAmount || 0
          return result + Number(unMask)
        }, 0)
      },
      linkToOrder: function (item) {
        const { href } = this.$router.resolve({
          name: 'edit-order',
          params: { id: item },
        })
        window.open(href, '_blank')
      },
      flattenFlexibleCombo(flexibleCombo) {
        const comboLines = flexibleCombo?.comboItems;
        if (!Array.isArray(comboLines)) {
          return [];
        }
        return comboLines.map((comboItem) => {
          return {
            // Giữ id dòng chi tiết từ DB khi cập nhật (trước đây gửi null khiến API không gắn được bill item)
            id:
              comboItem.id != null && comboItem.id !== ''
                ? comboItem.id
                : null,
            productId: comboItem.productId,
            productPrice: comboItem.sellingPrice ?? comboItem.productPrice ?? 0,
            quantity: comboItem.quantity || 1,
            discountAmount: comboItem.discountAmount || 0,
            imeiCode: comboItem.imeiCode,
            productType: 1,
            billItemType: 1,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            isGiftTaken: true,
            note: '',
            gifts: [],
            attachs: [],
            discountType: AMOUNT_TYPE.MONEY,
            discountProgramId: null,
            issuedVat: true,
            flexibleComboId: flexibleCombo.flexibleComboId,
            flexibleComboItemId: comboItem.flexibleComboItemId,
          }
        })
      },
      convertBillItem(items) {
        return items.map((billItem) => {
          return {
            id: billItem.id || null,
            productId: billItem.productId,
            productPrice: billItem.sellingPrice,
            quantity: billItem.quantity || 1,
            discountAmount: billItem.discountAmount || 0,
            imeiCode: billItem.imeiCode,
            billItemType: billItem.itemType,
            accessoryGroupId: billItem.accessoryGroupId,
            accessoryGroupCode: billItem.accessoryGroupCode,
            repurchasePrice: 0,
            isGiftTaken: billItem.checked,
            note: billItem.note,
            gifts: [],
            attachs: [],
            discountType: billItem.discountType,
            discountProgramId: null,
            belongBillDetailId: billItem.belongBillDetailId,
            checked: billItem.checked,
          }
        })
      },
      isValidImeiCode(billItems) {
        return billItems.every((item) => {
          if (item.productType !== PRODUCT_TYPE.PRODUCT_IMEI) {
            return true
          }

          return item.imeiCode && item.imeiCode.trim()
        })
      },
      setBillItems() {
        const mainItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && !billItem.flexibleComboId,
        )
        const flexibleComboBillItems = this.mainModel.billItems.filter(
          (billItem) => billItem.itemType === ITEM_TYPE.MAIN && billItem.flexibleComboId,
        )
        const giftItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.GIFT,
        )
        const attachItems = this.mainModel.billItems.filter(
          (item) => item.itemType === ITEM_TYPE.ATTACH,
        )

        const giftItemFormated = this.convertBillItem(giftItems)
        const attachItemFormated = this.convertBillItem(attachItems)

        const mainProductItems = []
        mainItems.forEach((billItem) => {
          const gifts = giftItemFormated.filter(
            (giftItem) => giftItem.belongBillDetailId === billItem.id,
          )
          const attachs = attachItemFormated.filter(
            (attchItem) => attchItem.belongBillDetailId === billItem.id,
          )

          const expanded = expandWholesaleImeiMainToPayloadRows(
            billItem,
            gifts,
            attachs,
            this.mainModel.billType,
          )
          if (expanded) {
            mainProductItems.push(...expanded)
            return
          }

          const linePayload = appendStackAmountsIfNeeded(
            {
            id: billItem.id || null,
            productId: billItem.productId,
            productPrice: billItem.sellingPriceMask || billItem.sellingPrice || 0,
            quantity: billItem.quantity || 1,
            discountAmount: billItem.discountAmount || 0,
            imeiCode: billItem.imeiCode,
            billItemType: billItem.itemType,
            accessoryGroupId: billItem.accessoryGroupId,
            accessoryGroupCode: billItem.accessoryGroupCode,
            repurchasePrice: 0,
            isGiftTaken: billItem.checked,
            note: billItem.note,
            gifts: gifts,
            attachs: attachs,
            discountType: billItem.discountType,
            discountProgramId: billItem.discountProgramId,
            issuedVat: billItem.isGetVat,
            merchantId: billItem.merchantId || 1,
            voucherId: billItem.voucherId || null,
            voucherDetailId: billItem.voucherDetailId || null,
            voucherCode: billItem.voucherCode || null,
            },
            billItem,
          )
          mainProductItems.push(linePayload)
        })
        let flexibleComboProductItems = []
        flexibleComboBillItems.forEach((flexibleComboBillItem) => {
          const flexibleComboTransformed = this.flattenFlexibleCombo(flexibleComboBillItem)
          flexibleComboProductItems = flexibleComboProductItems.concat(flexibleComboTransformed)
        })
        return mainProductItems.concat(flexibleComboProductItems)
      },
      setBillData() {
        logBillPaymentDebug('BillWholesaleInfo', this.mainModel, 'setBillData')
        const billItems = this.setBillItems()
        return {
          id: this.mainModel.id,
          billNumber: this.mainModel.billNumber || null,
          storeId: this.mainModel.storeId,
          //khach hang
          customerMobile: this.mainModel.customerModel.customerMobile.trim(),
          customerName: this.mainModel.customerModel.customerName.trim(),
          customerAddress: this.mainModel.customerModel.customerAddress,
          customerCity: this.mainModel.customerModel.customerCity,
          customerDistrict: this.mainModel.customerModel.customerDistrict,
          customerWard: this.mainModel.customerModel.customerWard,
          customerLastName: this.mainModel.customerModel.customerLastName,
          customerAppellation: this.mainModel.customerModel.customerAppellation,
          // giao hàng (người nhận)
          receiverName: (this.mainModel.receiverName || '').trim(),
          receiverMobile: (this.mainModel.receiverMobile || '').trim(),
          receiverAddress: this.mainModel.receiverAddress || '',
          orderSourceId: this.mainModel.orderSourceId,
          //nhan vien
          saleId: this.mainModel.billEmployeeInfo.saleId,
          technicalId: this.mainModel.billEmployeeInfo.technicalId,
          accessoryStaffId: this.mainModel.billEmployeeInfo.accessoryStaffId,
          cashierId: this.mainModel.billEmployeeInfo.cashierId,
          managerId: this.mainModel.billEmployeeInfo.managerId,
          assistantId: this.mainModel.billEmployeeInfo.assistantId,
          customerReceptionId: this.mainModel.billEmployeeInfo.customerReceptionId,
          shipperId: this.mainModel.billEmployeeInfo.shipperId,
          //ghi chu
          customerNote: this.mainModel.billNote.customerNote,
          saleNote: this.mainModel.billNote.saleNote,
          warrantyNote: this.mainModel.billNote.warrantyNote,
          //chiet khau
          discountType: this.mainModel.discountType,
          discountAmount: this.mainModel.discountAmount || 0,
          billItems: billItems,
          orderId: this.mainModel.orderId,
          //hoa don do
          vatCompanyName: this.mainModel.vatInvoice.companyName,
          vatCompanyAddress: this.mainModel.vatInvoice.companyAddress,
          vatCompanyType: this.mainModel.vatInvoice.vatCompanyType,
          email: this.mainModel.vatInvoice.email,
          taxCode: this.mainModel.vatInvoice.taxCode,
          //tieu diem
          pointUse: this.mainModel.subtractPoint || 0,
          isSubtractPointValidated: this.mainModel.isSubtractPointValidated,
          isCountPoint: this.mainModel.isCountPoint,
          //coupon
          isValidCouponCode: this.isValidCoupon,
          couponCode: this.mainModel.couponCode,
          // payment
          installments: this.mainModel.installments,
          credits: this.mainModel.credits,
          transfer: this.mainModel.transfer,
          cash: this.mainModel.cash,
          refunds: this.mainModel.refunds,
          //tien mat
          cashAmount: this.calcPaymentsAmount(this.mainModel.cash),
          cashAccountId: getFirstPaymentRefId(this.mainModel.cash),
          cashAccountCode: null,
          //chuyen khoan
          transferAmount: this.calcPaymentsAmount(this.mainModel.transfer),
          transferAccountID: getFirstPaymentRefId(this.mainModel.transfer),
          transferAccountCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          transferReferenceCode: getFirstPaymentRow(this.mainModel.transfer)?.paymentCode,
          //quet the
          creditAmount: this.calcPaymentsAmount(this.mainModel.credits),
          creditAccountId: getFirstPaymentRefId(this.mainModel.credits),
          creditAccountCode: getFirstPaymentRow(this.mainModel.credits)?.paymentCode,
          creditCode: getFirstPaymentRow(this.mainModel.credits)?.paymentCode,
          creditCardNo: getFirstPaymentRow(this.mainModel.credits)?.creditCardNo,
          //phi quet the
          otherFees: this.mainModel.paymentInfo.creditCardFee || 0,
          payCreditFeeType: this.mainModel.paymentInfo.payCreditFeeType,
          creditFeeAccountId: this.mainModel.paymentInfo.creditFeeAccountantId,
          creditFeeAcountCode: this.mainModel.paymentInfo.creditFeeAcountCode,
          //tra gop
          installedMoneyAmount: this.calcPaymentsAmount(this.mainModel.installments),
          installMoneyAccountId: getFirstPaymentRefId(this.mainModel.installments),
          installMoneyAccountCode: getFirstPaymentRow(this.mainModel.installments)?.paymentCode,
          customerIndentifyNo: getFirstPaymentRow(this.mainModel.installments)?.customerIndentifyNo,
          installMoneyCode: getFirstPaymentRow(this.mainModel.installments)?.installMoneyCode,
          billType: this.mainModel.billType,
          // B2B wholesale fields
          invoiceNo: this.mainModel.invoiceNo || null,
          serial: this.mainModel.serial || null,
        }
      },
      onCreateBill(payload) {
        ApiService.post('v1/bills', payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            this.onBack()
          })
          .catch((error) => {
            this.onSubmiting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      printBill: async function () {
        const routeData = this.$router.resolve({
          name: 'print-bill',
          query: { id: this.mainModel.billNumber },
        })
        window.open(routeData.href, '_self')
      },
      onUpdateBill(payload, action) {
        ApiService.put(`v1/bills/`, payload)
          .then(({ data }) => {
            makeToastSuccess(data.message)
            if (action === 'save-print') {
              this.printBill()
            } else {
              this.onBack()
            }
          })
          .catch((error) => {
            this.onSubmiting = false
            const message = error?.response?.data?.message || 'Lỗi!'
            makeToastFaile(message)
          })
      },
      onSubmit(action) {
        this.onSubmiting = true
        logBillPaymentDebug('BillWholesaleInfo', this.mainModel, `onSubmit:${action}`)

        if (!this.mainModel.storeId) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng chọn cửa hàng!')
        }

        if (!this.mainModel.billItems.length) {
          this.onSubmiting = false
          return makeToastFaile('Bạn chưa chọn sản phẩm nào')
        }

        if (!this.isValidImeiCode(this.mainModel.billItems)) {
          this.onSubmiting = false
          return makeToastFaile('Vui lòng nhập mã IMEI cho sản phẩm IMEI')
        }

        const billData = this.setBillData()
        if (this.mainModel.id) {
          this.onUpdateBill(billData, action)
        } else {
          this.onCreateBill(billData)
        }
      },
      onUpdateCustomer(customerInfo) {
        this.mainModel.customerModel = cloneDeep(customerInfo)
      },
      async loadOptionOrderSources() {
        const result = await this.fetchOrderSources()
        this.optionOrderSources = this.mapDataTreeSelect(result, ['id', 'name'])
      },
      mapDataTreeSelect(items = [], keys = []) {
        return items.map((element) => {
          return {
            id: element[keys[0]],
            label: element[keys[1]],
            shortName: element[keys[2]],
          }
        })
      },
      combineFlexibleCombo(billItems) {
        const flexibleComboIds = _uniq(
          billItems.map((flexibleComboBillItem) => flexibleComboBillItem.flexibleComboId),
        )
        return flexibleComboIds.map((flexibleComboId) => {
          const flexibleComboItems = billItems.filter(
            (billItem) => billItem.flexibleComboId === flexibleComboId,
          )
          let comboName = ''
          if (flexibleComboItems.length) {
            comboName = flexibleComboItems[0].flexibleComboName
          }
          const comboItems = flexibleComboItems.map((flexibleComboItem) => {
            return {
              id: flexibleComboItem.id,
              productCode: flexibleComboItem.productCode ? flexibleComboItem.productCode : '',
              productName: flexibleComboItem.productName ? flexibleComboItem.productName : '',
              quantity: flexibleComboItem.quantity,
              productId: flexibleComboItem.productId,
              productPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              sellingPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              productType: PRODUCT_TYPE.PRODUCT,
              discountAmount: flexibleComboItem.discountAmount,
              productComboPrice: 0,
              productComboRate: 0,
              productVatAmount: flexibleComboItem.productVatAmount,
              productNameVat: flexibleComboItem.productNameVat
                ? flexibleComboItem.productNameVat
                : '',
              listedPrice: flexibleComboItem.productPrice ? flexibleComboItem.productPrice : 0,
              flexibleComboItemId: flexibleComboItem.flexibleComboItemId ?? null,
            }
          })
          const flexibleComboPrice = comboItems.reduce((result, product) => {
            result += product.productPrice * product.quantity - product.discountAmount
            return result
          }, 0)
          return {
            id: flexibleComboId,
            productId: flexibleComboId,
            productName: comboName,
            productCode: '',
            productNameVat: '',
            productNote: '',
            productType: PRODUCT_TYPE.PRODUCT_COMBO,
            quantity: 1,
            productPrice: flexibleComboPrice,
            imeiCode: '',
            totalPrice: flexibleComboPrice,
            discount: 0,
            discountType: AMOUNT_TYPE.PERCENT,
            comboItems: comboItems,
            itemType: ITEM_TYPE.MAIN,
            checked: true,
            accessoryGroupId: null,
            accessoryGroupCode: '',
            repurchasePrice: 0,
            belongBillDetailId: null,
            note: '',
            listAccessoryPromotion: [],
            listProductPromotion: [],
            issuedVat: true,
            sellingPrice: flexibleComboPrice,
            sellingPriceMask: flexibleComboPrice,
            listedPrice: flexibleComboPrice,
            flexibleComboId: flexibleComboId,
          }
        })
      },
      getBillByBillNumber() {
        ApiService.get(`v1/bills/${this.mainModel.billNumber}`).then(async (response) => {
          const dataRes = response.data.data
          const {
            id,
            storeId,
            storeName,
            saleNote,
            customerNote,
            warrantyNote,
            customerTaxCode,
            customerId,
            discountAmount,
            discountType,
            orderSourceId,
            orderSourceName,
            customerShipFee,
            codeShip,
            cashAmount,
            cashAccountId,
            cashAccName,
            cashAccountCode,
            transferAmount,
            transferAccountId,
            transferAccName,
            transferAccountCode,
            transferReferenceCode,
            creditAmount,
            creditAccountId,
            creditAccName,
            creditAccountCode,
            creditCardNo,
            creditCode,
            otherFees,
            payCreditFeeType,
            creditFeeAcountId,
            creditFeeAccName,
            creditFeeAcountCode,
            installedMoneyAmount,
            installMoneyAccountId,
            installmentAccName,
            customerIndentifyNo,
            installMoneyCode,
            depositAmount,
            transferFromOrder,
            moneyCredit,
            moneyInstallment,
            pointToMoney,
            subtractPoint,
            couponCode,
            billItems,
            editable,
            hasExchange,
            exchangeBillNumbers,
            isSubtractPointValidated,
            isCountPoint,
            payments,
            createdAt,
            // tradeIn,
            customerAppellation,
          } = dataRes
          // this.tradeIn = { ...tradeIn };
          this.mainModel.id = id
          this.mainModel.storeId = storeId
          this.mainModel.storeName = storeName
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.customerModel.customerMobile = dataRes.customerPhone
          this.mainModel.customerModel.customerAddress = dataRes.customerAddress
          this.mainModel.customerModel.customerName = dataRes.customerName
          this.mainModel.customerModel.customerCity = dataRes.customerCity
          this.mainModel.customerModel.customerWard = dataRes.customerWard
          this.mainModel.customerModel.customerDistrict = dataRes.customerDistrict
          this.mainModel.customerModel.totalPoint = dataRes.customerPoint
          this.mainModel.customerModel.customerAppellation = customerAppellation
          this.mainModel.customerModel.customerTaxCode = customerTaxCode || ''
          this.mainModel.receiverName = dataRes.receiverName || ''
          this.mainModel.receiverMobile = dataRes.receiverMobile || ''
          this.mainModel.receiverAddress = dataRes.receiverAddress || ''
          this.mainModel.orderSourceId = orderSourceId
          this.optionOrderSources = orderSourceId
            ? [{ id: orderSourceId, label: orderSourceName || '' }]
            : null
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0
          this.mainModel.discountType = discountType
          this.mainModel.codeShip = codeShip
          this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0
          this.mainModel.billEmployeeInfo.saleId = dataRes.saleId
          this.mainModel.billEmployeeInfo.saleName = dataRes.saleName
          this.mainModel.billEmployeeInfo.technicalId = dataRes.technicalId
          this.mainModel.billEmployeeInfo.technicalName = dataRes.techName
          this.mainModel.billEmployeeInfo.cashierId = dataRes.cashierId
          this.mainModel.billEmployeeInfo.cashierName = dataRes.cashierName
          this.mainModel.billEmployeeInfo.managerId = dataRes.managerId
          this.mainModel.billEmployeeInfo.managerName = dataRes.managerName
          this.mainModel.billEmployeeInfo.assistantId = dataRes.assistantId
          this.mainModel.billEmployeeInfo.assistantName = dataRes.assistantName
          this.mainModel.billEmployeeInfo.customerReceptionId = dataRes.customerReceptionId
          this.mainModel.billEmployeeInfo.customerReceptionName = dataRes.customerReceptionName
          this.mainModel.billEmployeeInfo.accessoryStaffId = dataRes.accessoryStaffId
          this.mainModel.billEmployeeInfo.accessoryStaffName = dataRes.accessoryStaffName
          this.mainModel.billEmployeeInfo.shipperId = dataRes.shipperId
          this.mainModel.billEmployeeInfo.shipperName = dataRes.shipperName
          this.mainModel.paymentInfo.cashAmount = cashAmount
          this.mainModel.paymentInfo.cashAccountId = cashAccountId
          this.mainModel.paymentInfo.cashAccountantName = cashAccName
          this.mainModel.paymentInfo.cashAccountCode = cashAccountCode
          this.mainModel.paymentInfo.transferAmount = transferAmount
          this.mainModel.paymentInfo.transferAccountantId = transferAccountId
          this.mainModel.paymentInfo.transferAccountantName = transferAccName
          this.mainModel.paymentInfo.transferAccountCode = transferAccountCode
          this.mainModel.paymentInfo.transferReferenceCode = transferReferenceCode
          this.mainModel.paymentInfo.creditAmount = creditAmount
          this.mainModel.paymentInfo.creditAccountantId = creditAccountId
          this.mainModel.paymentInfo.creditAccountCode = creditAccountCode
          this.mainModel.paymentInfo.creditAccountantName = creditAccName
          this.mainModel.paymentInfo.creditCardNo = creditCode
          this.mainModel.paymentInfo.creditCardCode = creditCardNo
          this.mainModel.paymentInfo.creditCardFee = otherFees
          this.mainModel.paymentInfo.payCreditFeeType = payCreditFeeType
          this.mainModel.paymentInfo.creditFeeAccountantId = creditFeeAcountId
          this.mainModel.paymentInfo.creditFeeAcountCode = creditFeeAcountCode
          this.mainModel.paymentInfo.creditFeeAccountantName = creditFeeAccName
          this.mainModel.paymentInfo.installedMoneyAmount = installedMoneyAmount
          this.mainModel.paymentInfo.installMoneyAccountId = installMoneyAccountId
          this.mainModel.paymentInfo.installmentAccountName = installmentAccName
          this.mainModel.paymentInfo.customerIndentifyNo = customerIndentifyNo
          this.mainModel.paymentInfo.installmentCode = installMoneyCode
          this.mainModel.orderId = dataRes.orderId
          this.mainModel.moneyTransfered = transferFromOrder
          this.mainModel.moneyPaid = depositAmount
          this.mainModel.moneyCredit = moneyCredit
          this.mainModel.moneyInstallment = moneyInstallment
          this.mainModel.totalAmountPoint = pointToMoney
          this.mainModel.subtractPoint = subtractPoint
          this.prevSubtractPoint = subtractPoint
          this.mainModel.isSubtractPointValidated = isSubtractPointValidated
          this.mainModel.isCountPoint = isCountPoint
          this.mainModel.couponCode = couponCode
          this.prevCouponCode = couponCode
          this.mainModel.vatInvoice.companyName = dataRes.companyName
          this.mainModel.vatInvoice.companyAddress = dataRes.vatCompanyAddress
          this.mainModel.vatInvoice.vatCompanyType = dataRes.vatCompanyType
          this.mainModel.vatInvoice.email = dataRes.email
          this.mainModel.vatInvoice.taxCode = dataRes.taxCode
          this.mainModel.companyBill = dataRes.taxCode ? true : false
          this.mainModel.billNote.customerNote = dataRes.customerNote
          this.mainModel.billNote.saleNote = dataRes.saleNote
          this.mainModel.billNote.warrantyNote = dataRes.warrantyNote
          this.mainModel.hasExchange = !!hasExchange
          this.mainModel.exchangeBillNumbers = exchangeBillNumbers || []

          if (dataRes.einvoice) {
            this.mainModel.einvoice = dataRes.einvoice
          }
          // BE đã fold einvoice-lock + permission BILL_ALLOW_EDIT_WHEN_EINVOICE_EXISTS vào `editable`.
          this.mainModel.editable = editable
          this.mainModel.billCreatedAt = createdAt
          this.mainModel.invoiceNo = dataRes.einvoice?.invoiceNo?.trim() || null
          this.mainModel.serial = dataRes.einvoice?.serial?.trim() || null
          this.mainModel.installments = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.INSTALLMENT,
          )
          this.mainModel.credits = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.CREDIT,
          )
          this.mainModel.transfer = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.TRANSFER,
          )
          this.mainModel.cash = payments.filter((item) => item.paymentType === PAYMENT_TYPE.CASH)
          this.mainModel.refunds = payments.filter(
            (item) => item.paymentType === PAYMENT_TYPE.REFUND,
          )
          const flexibleComboBillItems = billItems.filter((billItem) => billItem.flexibleComboId)
          const normalBillItems = billItems.filter((billItem) => !billItem.flexibleComboId)
          const flexibleComboItems = this.combineFlexibleCombo(flexibleComboBillItems)
          const mappedNormal = normalBillItems.map((billItem) => {
            const row = {
              id: billItem.id,
              productId: billItem.productId,
              productName: billItem.productName,
              productNameVat: billItem.productNameVat,
              barCode: billItem.barCode,
              productCode: billItem.productCode,
              imageUrl: billItem.imageUrl,
              sellingPrice: billItem.productPrice,
              sellingPriceMask: billItem.productPrice,
              productType: billItem.productType,
              quantity: billItem.quantity,
              imeiCode: billItem.imeiCode,
              totalPrice: billItem.quantity * billItem.productPrice - billItem.discountAmount,
              discountAmount:
                billItem.discountUnitAmount != null
                  ? billItem.discountUnitAmount
                  : billItem.discountAmount,
              comboItems: billItem.listProductInCombo,
              itemType: billItem.billItemType,
              repurchasePrice: billItem.repurchasePrice ? billItem.repurchasePrice : 0,
              accessoryGroupId: billItem.accessoryGroupId ? billItem.accessoryGroupId : '',
              accessoryGroupCode: billItem.accessoryGroupCode ? billItem.accessoryGroupCode : '',
              note: billItem.note,
              belongBillDetailId: billItem.belongBillDetailId,
              listAccessoryPromotion: billItem.listProductPromotion,
              quantityInStock: billItem.quantityInStock,
              storeId: storeId,
              discountType: parseInt(billItem.discountType),
              discountProgramId: billItem.discountProgramId,
              isGetVat: billItem.issuedVat === 1 ? true : false,
              disabledByInstallmentProgram: this.applyInstallmentProgram ? true : false,
              isInstallmentProgramProduct: this.applyInstallmentProgram ? true : false,
              listedPrice: billItem.listedPrice || 0,
              flexibleComboId: billItem.flexibleComboId || null,
              voucherId: billItem.voucherId || null,
              voucherDetailId: billItem.voucherDetailId || null,
              voucherCode: billItem.voucherCode || null,
              voucherCumluativeValues: billItem.cumluativeValues || [],
              promotionProgramCode: billItem.promotionProgramCode || '',
              promotionProgramName: billItem.promotionProgramName || '',
            }
            hydrateSplitAmountsFromApi(row, billItem.discountProgramAmount, billItem.voucherAmount)
            normalizePromotionLabelsFromHydrate(row, billItem)
            return row
          })
          this.mainModel.billItems = mergeWholesaleImeiBillRowsForDisplay(
            mappedNormal,
            this.billType,
          )
          this.mainModel.billItems = this.mainModel.billItems.concat(flexibleComboItems)
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          setTimeout(() => {
            this.renderComponent = true
          }, TIME_TRIGGER)
        })
      },
      getOrderById() {
        ApiService.query(`v1/orders/${this.mainModel.orderId}`).then((data) => {
          const {
            saleNote,
            customerNote,
            customerId,
            discountAmount,
            discountType,
            transferAmount,
            depositAmount,
            storeId,
            orderItems,
            orderSourceId,
            storeName,
            creditAmount,
            installedMoneyAmount,
            customerShipFee,
            warrantyNote,
            codeShip,
            saleStoreId,
            saleStoreName,
          } = data.data.data
          this.mainModel.billNote.warrantyNote = warrantyNote
          this.mainModel.storeId = storeId
          this.mainModel.storeName = storeName
          this.mainModel.billEmployeeInfo.saleId = saleStoreId
          this.mainModel.billEmployeeInfo.saleName = saleStoreName
          this.mainModel.billNote.saleNote = saleNote
          this.mainModel.billNote.customerNote = customerNote
          this.mainModel.customerModel.customerId = customerId
          this.mainModel.discountAmount = discountAmount ? discountAmount : 0
          this.mainModel.discountType = discountType
          this.searchStore = storeName
          this.mainModel.orderSourceId = orderSourceId
          this.mainModel.moneyTransfered = transferAmount
          this.mainModel.moneyPaid = depositAmount
          this.mainModel.moneyCredit = creditAmount
          this.mainModel.moneyInstallment = installedMoneyAmount
          this.mainModel.codeShip = codeShip
          this.mainModel.customerModel.customerMobile = data.data.data.customerMobile
          this.mainModel.customerModel.customerAddress = data.data.data.customerAddress
          this.mainModel.customerModel.customerName = data.data.data.customerName
          this.mainModel.customerModel.customerCity = data.data.data.customerCity
          this.mainModel.customerModel.customerWard = data.data.data.customerWard
          this.mainModel.customerModel.customerDistrict = data.data.data.customerDistrict
          this.mainModel.vatInvoice.companyAddress = data.data.data.vatCompanyAddress
          this.mainModel.vatInvoice.companyName = data.data.data.vatCompanyName
          this.mainModel.vatInvoice.taxCode = data.data.data.taxCode
          this.mainModel.vatInvoice.email = data.data.data.email
          this.mainModel.couponCode = data.data.data.couponCode
          this.isValidCoupon = data.data.data.couponCode ? true : false
          this.mainModel.customerShipFee = customerShipFee ? customerShipFee : 0
          this.mainModel.customerModel.totalPoint = data.data.data.customerPoint
          this.mainModel.subtractPoint = data.data.data.subtractPoint
          this.mainModel.totalAmountPoint = data.data.data.subtractPointAmount
          this.mainModel.isSubtractPointValidated =
            data.data.data.subtractPointAmount > 0 ? true : false
          this.mainModel.billItems = orderItems.map((orderItem) => {
            return {
              id: orderItem.id,
              productId: orderItem.productId,
              barCode: orderItem.productBarCode,
              productName: orderItem.productName,
              productCode: orderItem.productCode,
              productNameVat: orderItem.productNameVat,
              productType: orderItem.productType,
              sellingPrice: orderItem.productPrice,
              sellingPriceMask: orderItem.productPrice,
              imeiCode: orderItem.imeiCode,
              quantity: orderItem.quantity,
              totalPrice: orderItem.totalAmount,
              discountAmount:
                orderItem.orderItemType === AMOUNT_TYPE.MONEY ? orderItem.discountAmount : 0,
              discountType: AMOUNT_TYPE.MONEY,
              quantityInStock: orderItem.quantityInStock,
              comboItems:
                orderItem.comboItems ||
                orderItem.productInCombos ||
                orderItem.listProductInCombo ||
                [],
              flexibleComboId: orderItem.flexibleComboId ?? null,
              storeId: storeId,
              deleted: orderItem.deleted,
              itemType: orderItem.orderItemType,
              repurchasePrice: orderItem.repurchasePrice ? orderItem.repurchasePrice : 0,
              checked: true,
              listAccessoryBonus: [],
              note: orderItem.note ? orderItem.note : '',
              listAccessoryPromotion: orderItem.listAccessoryPromotion
                ? orderItem.listAccessoryPromotion
                : [],
              belongBillDetailId: orderItem.belongOrderDetailId,
              isGetVat: false,
            }
          })
          this.mainModel.billItems = sortListBillItem(this.mainModel.billItems)
          this.renderComponent = true
        })
      },
      openHistoryModal(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      handleOpenModalFromUrl(historyId) {
        this.selectedHistoryId = historyId
        this.showHistoryModal = true
      },
      checkModalFromUrl() {
        const urlParams = new URLSearchParams(window.location.search)
        const modal = urlParams.get('modal')
        const historyId = urlParams.get('id')

        if (modal === 'bill-history' && historyId) {
          this.openHistoryModal(historyId)
        }
      },
      fetchBillHistory: async function () {
        const params = {
          //  loại hóa đơn
          type: 2,
        }
        await ApiService.query('/v1/histories/getByReferenceId/' + this.mainModel.billNumber, {
          params,
        }).then((res) => {
          const resData = res.data.data || []
          this.histories = resData.map((data) => {
            return {
              id: data.id,
              type: data.type,
              referenceId: data.referenceId,
              action: data.action,
              originalValue: data.originalValue,
              newValue: data.newValue,
              updatedBy: data.updatedBy,
              userAgent: data.userAgent,
              userIP: data.userIP,
              createdByName: data.createdByName,
              createdAt: moment(String(data.createdAt)).format('DD/MM/YYYY HH:mm'),
              updatedAt: moment(data.updatedAt).format('DD/MM HH:mm'),
            }
          })
        })
      },
      showOrders(notCompleteOrders) {
        this.notCompleteOrders = notCompleteOrders
      },
    },
  }
</script>

<style lang="scss">
  .bill-info {
  .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
    flex: 0 0 calc(15% - 0.25rem);
  }

  @media (max-width: 1399.98px) {
    .wizard.wizard-4 .wizard-nav .wizard-steps .wizard-step {
      flex: 0 0 calc(17% - 0.25rem);
    }
  }

  .wizard-nav-bg {
    background-color: #f7f7f7;
    border-radius: 5px 5px 0px 0px;
  }

  .alert-header {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
    color: #856404;
    background-color: #fff3cd;
    border-color: #ffeeba;
  }
  .box {
    background: black;
    border-radius: 4px;
    padding-bottom: 100%;
  }
  .headerTable {
    color: rgb(24, 28, 50);
    text-align: center;
  }

  .form-group label {
    font-weight: 500;
    margin-bottom: 4px;
  }

  .form-group {
    margin-bottom: 16px;
  }

  .textExcessCash {
    font-weight: 500;
    color: rgba(71, 71, 255, 0.87);
  }
  .row-center-vertical {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textPoint {
    font-size: 14px;
    font-weight: 500;
  }
  .textFinal {
    font-weight: 500;
    color: brown;
  }
  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }

  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }

  .no-side {
    padding-left: 0px;
    padding-right: 0px;
  }
  .dropdown-custom {
    .btn-sm,
    .btn-group-sm > .btn {
      padding: 1px 2px;
      background-color: transparent;
      border: none;
      border-radius: 3px;
    }
  }

  .bill-main-sections {
    align-items: stretch;
  }

  .bill-main-sections__left,
  .bill-main-sections__right {
    display: flex;
    flex-direction: column;
  }

  .bill-main-sections__left .bill-product-table,
  .bill-main-sections__right .bill-checkout-form {
    height: 100%;
  }

  .bill-main-sections__right .bill-checkout-form {
    margin-top: 8px;
  }

  .bill-main-sections__left--wholesale .bill-product-table {
    height: auto;
  }
}
</style>

<style lang="scss">
  @import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>

<style lang="scss">
  .upload-file {
  table {
    table-layout: fixed;
  }
  .dropbox {
    margin: auto;
    width: 70%;
    background: #f8f8f8;
    border-radius: 20px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0; /* invisible but it's there! */
    left: 0px;
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: #e8f5e9;
  }

  .dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
  }
  .img-container {
    position: relative;
    display: inline-block;
    width: 80px;
    margin: 0px 10px;
  }
  .preview-img {
    max-width: 80px;
    padding: 10px;
    object-fit: contain;
    border: 1px solid #eeecff;
    border-radius: 5px;
  }
  .preview-img-container {
    border: 2px dashed #eeecff;
    padding: 2rem 1rem;
  }

  .preview-box {
    display: inline-block;
  }
  .close {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 15px;
  }
  .remove {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 15px;
  }
  .cancel {
    color: #545454;
    text-decoration: none;
  }
}
</style>

